module.exports = __webpack_public_path__ + "static/media/aluminio-placa-antiderrapante.9d08173d.jpg";